<div class="flex justify-center items-center w-full" [style.min-height]="minHeight">
    <div class="flex flex-col items-center gap-4 justify-center p-10">
        <img [src]="imagePath" [style.width]="imageWidth" [style.height]="imageHeight" class="object-contain opacity-80" [alt]="title" />
        <div class="text-2xl font-semibold text-gray-700 text-center">{{ title }}</div>
        <div class="text-gray-500 text-base text-center max-w-md">{{ description }}</div>
    </div>
</div>